import { useClassNames } from "@/utils/classNames";

import styles from "./RatingsBadge.module.scss";
import {
  RatingsBadgeProps,
  RatingsBadgeVariant,
  RatingsBadgeSize,
} from "./types";

/**
 * RatingsBadge component displays a text badge of the content rating.
 *
 * @param variant - Visual style of the badge
 * @param size - Size of the badge
 * @param className - Additional CSS class for styling
 * @param children - Content to display inside the badge
 * @param attr - Additional HTML attributes to pass to the rendered element
 *
 * @returns the rendered RatingsBadge component
 *
 * @example
 * ```tsx
 * <RatingsBadge
 *   variant={RatingsBadgeVariant.Secondary}
 *   size={RatingsBadgeSize.Small}
 * >
 *   PG13
 * </RatingsBadge>
 * ```
 */
const RatingsBadge = ({
  variant = RatingsBadgeVariant.Primary,
  size = RatingsBadgeSize.Medium,
  className,
  children,
  ...attr
}: RatingsBadgeProps) => {
  const cn = useClassNames(
    styles,
    styles["ratings-badge"],
    styles[variant],
    styles[`size-${size}`],
    className,
  );

  return (
    <div className={cn} {...attr}>
      {children}
    </div>
  );
};

export { RatingsBadge };
